<template>
    <div class="row">
        <div class="col-12 d-md-flex w-100 d-none">
            <div class="_table w-100">
                <b-table
                    :fields="fields"
                    :items="items"
                    :tbody-tr-class="tableRow"
                >
                    <template #cell(created_at)="{item}">
                        <span>{{ item.created_at | momentDate(item.created_at) }}</span>
                    </template>
                    
                    <template #cell(status)="{item}">
                        <span v-if="item.status === 1">
                          {{ $t('messageStatus.waterRound1') }}
                        </span>
                                    <span v-else-if="item.status === 2">
                          {{ $t('messageStatus.waterRound2') }}
                        </span>
                                    <span v-else-if="item.status === 3">
                          {{ $t('messageStatus.waterRound3') }}
                        </span>
                                    <span v-if="item.status === 4">
                          {{ $t('messageStatus.waterRound4') }}
                        </span>
                                    <span v-if="item.status === 5">
                          {{ $t('messageStatus.waterRound5') }}
                        </span>
                                    <span v-if="item.status === 6">
                          {{ $t('messageStatus.waterRound6') }}
                        </span>
                    </template>
                    
                    <template #cell(actions)="{item}">
                        <div class="d-flex align-items-center gap-2">
                            <!-- <b-button
                              variant="primary"
                              size="sm"
                              @click="gotoProduct(item.id)"
                            >
                              <i class="bx bxs-file-doc fs-4"></i>
                            </b-button> -->
                            
                            <b-button
                                v-if="item.status === 1"
                                variant="success"
                                size="sm"
                                @click="handleEditStatus(item.id)"
                            >
                                <i class="bx bx-archive fs-4"></i>
                            </b-button>
                            
                            <b-button
                                v-if="item.debt_payments.length !== 0"
                                class="relative"
                                variant="warning"
                                size="sm"
                                @click="handlePayDebt(item)"
                            >
                                <i class='bx bx-dollar fs-4'></i>
                                <span
                                    class="bg-danger rounded-pill absotute"
                                    v-if="item.debt_payments.filter(val => val.status_id === 1).length !== 0"
                                >{{
                                        item.debt_payments.filter(val => val.status_id === 1).length
                                    }}</span>
                            </b-button>
                            
                            <b-button
                                v-if="item.status === 4"
                                variant="success"
                                size="sm"
                                @click="handleFinish(item)"
                            >
                                <i class="bx bx-check-double fs-4"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="row d-md-none d-flex mt-3">
            <div class="col-md-6" v-for="(item, index) in items" :key="index">
                <div class="card " :class="[item.status == 3 ? 'bg-danger text-white' : '', item.status == 4 ? 'bg-warning text-white' : '']">
                    <div class="card-body">
                        <div v-for="(field, idx) in fields" :key="idx">
                            <div class="d-flex align-items-center justify-content-between border-bottom border-2 py-1" v-if="field.label !== 'Sana' && field.label !== 'Harakatlar' && field.label !== 'Holati'">
                                <strong class="fs-5">{{field.label}}</strong>
                                <p class="mb-0 fs-5">{{item[field.key] === undefined ? checkItems(field.key, item) : item[field.key]}}</p>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-bottom border-2 py-1" v-else-if="field.label === 'Sana'">
                                <strong class="fs-5">{{field.label}}</strong>
                                <span class="fs-5">{{ item.created_at | momentDate(item.created_at) }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-bottom border-2 py-1" v-else-if="field.label === 'Holati'">
                                <strong class="fs-5">{{field.label}}</strong>
                                <span class="fs-5" v-if="item.status === 1">{{ $t('messageStatus.waterRound1') }}</span>
                                <span class="fs-5" v-else-if="item.status === 2">{{ $t('messageStatus.waterRound2') }}</span>
                                <span class="fs-5" v-else-if="item.status === 3">{{ $t('messageStatus.waterRound3') }}</span>
                                <span class="fs-5" v-if="item.status === 4">{{ $t('messageStatus.waterRound4') }}</span>
                                <span class="fs-5" v-if="item.status === 5">{{ $t('messageStatus.waterRound5') }}</span>
                                <span class="fs-5" v-if="item.status === 6">{{ $t('messageStatus.waterRound6') }}</span>
                            </div>
                            <div v-else-if="field.label === 'Harakatlar'" class="pt-2 d-flex align-items-center justify-content-center">
                                <b-button v-if="item.status === 1" variant="success" size="sm" @click="handleEditStatus(item.id)">
                                    <i class="bx bx-archive fs-4"></i>
                                </b-button>
                                <b-button v-if="item.debt_payments.length !== 0" class="relative" variant="warning" size="sm" @click="handlePayDebt(item)">
                                    <i class='bx bx-dollar fs-4'></i>
                                    <span class="bg-danger rounded-pill absotute" v-if="item.debt_payments.filter(val => val.status_id === 1).length !== 0">
                                        {{item.debt_payments.filter(val => val.status_id === 1).length}}
                                    </span>
                                </b-button>
                                <b-button v-if="item.status === 4" variant="success" size="sm" @click="handleFinish(item)">
                                    <i class="bx bx-check-double fs-4"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-12">
            <b-pagination v-model="pagination.page" :total-rows="total" :per-page="pagination.pageSize" @input="fetchData(pagination)"></b-pagination>
        </div>
        <b-modal v-model="actionModal" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
            <ActionModal :id="id" @onClose="handleCloseModal"/>
        </b-modal>
        <b-modal v-model="finishModal" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
            <FinishModal :finishOptions="finishOptions" @onClose="handleCloseFinish"/>
        </b-modal>
        <b-modal v-model="payModal" no-close-on-backdrop no-close-on-esc hide-footer hide-header>
            <div class="container" v-if="payObj !== null">
                <h5>{{ $t('modal.form.manager_id') }}: <b>{{ payObj.manager.full_name }}</b></h5>
                <h5>REYS:{{ payObj.name }}</h5>
                <div>
                    <div class="d-flex w-100 justify-content-between my-1" v-for="(obj, index) in payObj.debt_payments" :key="index">
                        <div class="w-100" :class="obj.status_id === 3 ? 'text-danger' : ''">
                            <div>
                                <span>{{ $t('modal.form.debt') }}</span>: <b>{{ obj.price }}</b>
                            </div>
                            <div>
                                {{ $t('modal.form.data') }}: <b>{{ obj.created_at | momentDate(obj.created_at) }}</b>
                            </div>
                        </div>
                        <div v-if="obj.status_id === 1" class="d-flex w-100 justify-content-end gap-2 align-items-center">
                            <b-button variant="danger" size="sm" :disabled="db" @click="handlePayReject(obj)">
                                <i class='bx bx-x fs-5'></i>
                            </b-button>
                            <b-button variant="success" size="sm" :disabled="db" @click="handlePayAccept(obj)">
                                <i class='bx bx-check fs-5'></i>
                            </b-button>
                        </div>
                    </div>
                </div>
                <div class="w-100 d-flex justify-content-end align-items-center gap-2 mt-2">
                    <b-button variant="warning" @click="handlePayModalClose">{{ $t('modal.button.back') }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ActionModal from './components/ActionModal';
import FinishModal from './components/FinishModal';
import {isPayStatusDebt} from '../../../api/endpoints/driverWaterRounds';
import moment from "moment";

export default {
    name: "DriverWaterRounds",
    components: {
        ActionModal,
        FinishModal
    },
    filters:{
        momentDate(date) {
            return moment(date).add(2, 'hours').format('DD-MM-YYYY HH:mm')
        }
    },
    data() {
        return {
            fields: [
                {key: "id", label: "№"},
                {key: "created_at", label: this.$t('modal.form.data')},
                {key: "name", label: 'REYS'},
                {key: "manager.full_name", label: this.$t('modal.form.manager_id')},
                {key: "status", label: this.$t('table.status.label')},
                {key: 'total_products_quantity', label: this.$t('table.total_products_quantity')},
                {key: "driver_debt", label: this.$t('modal.form.debt_driver_money')},
                {key: "actions", label: this.$t('table.actions.label')}
            ],
            actionModal: false,
            id: null,
            finishOptions: null,
            finishModal: false,
            pagination: {
                page: 1,
                pageSize: 20,
            },
            payModal: false,
            payReject: false,
            form: {
                debt: null
            },
            payObj: null,
            db: false,
        }
    },
    computed: {
        ...mapGetters('driverWaterRounds', ['items', 'total']),
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        ...mapActions('driverWaterRounds', ['fetchData']),
        handleEditStatus(id) {
            this.actionModal = true;
            this.id = id;
        },
        handleCloseModal() {
            this.id = null;
            this.fetchData();
            this.actionModal = false;
        },
        gotoProduct(id) {
            this.$router.push("/driver/water-rounds/" + id)
        },
        handleFinish(item) {
            this.finishOptions = item;
            this.finishModal = true
        },
        handleCloseFinish() {
            this.finishModal = false;
            this.fetchData();
        },
        handlePayModalClose() {
            this.payModal = false;
            this.payObj = null;
            this.fetchData();
        },
        handlePayAccept(obj) {
            this.db = true;
            setTimeout(() => {
                this.db = false;
            }, 700)
            isPayStatusDebt({
                payment_id: obj.id,
                status_id: 2
            }).then(() => {
                this.handlePayModalClose();
            })
        },
        handlePayReject(obj) {
            this.db = true;
            setTimeout(() => {
                this.db = false;
            }, 700)
            isPayStatusDebt({
                payment_id: obj.id,
                status_id: 3
            }).then(() => {
                this.handlePayModalClose();
            })
        },
        handlePayDebt(obj) {
            this.payModal = true;
            this.payObj = obj
        },
        tableRow(item, type) {
            if (!item || type !== 'row') return ""
            if (item.driver_id) {
                if (item.status == 3) return 'table-danger'
                if (item.status == 4) return 'table-warning'
            }
        },
        checkItems(a, b) {
            let _f = a;
            let _i = {...b}
            let dodCount = 0;
            let objectKeys = {};
            let createObject = null;
        
            for (let i = 0; i < a.length; i++) if(a[i] === '.') dodCount++
            for (let i = 0; i <= dodCount ; i++) {
                if(i === dodCount) objectKeys[i] = _f
                else {
                    let idx = _f.indexOf('.');
                    objectKeys[i] = _f.slice(0, idx);
                    _f = _f.replace(`${_f.slice(0, idx)}.`, '')
                }
            }
            for (let i = 0; i <=dodCount ; i++) {
                if(i === 0) {
                    try {createObject = _i[objectKeys[i]]}
                    catch (error) {createObject = ''}
                } else {
                    try {createObject = createObject[objectKeys[i]]}
                    catch (error) {createObject = ''}
                }
            }
            return createObject
        },
    }
}
</script>

<style lang="scss">
.absotute {
    position: absolute;
    top: -10px;
    right: -10px;
}

.relative {
    position: relative;
}
</style>
